import { createSlice } from "@reduxjs/toolkit";

interface DataGroupModalState {
    isChangeDataGroupVisible: boolean;
}

const initialState: DataGroupModalState = {
    isChangeDataGroupVisible: false,
};

export const dataGroupModalState = createSlice({
    name: "DataGroupModalSlice",
    initialState,
    reducers: {
        openChangeDataGroup: (state) => {
            return { ...state, isChangeDataGroupVisible: true };
        },
        closeChangeDataGroup: (state) => {
            return { ...state, isChangeDataGroupVisible: false };
        },
    },
});

export const { openChangeDataGroup, closeChangeDataGroup } = dataGroupModalState.actions;
